import { User } from '../users/entities.js';

export enum ContractType {
    TERMS_AND_CONDITIONS = 'TERMS_AND_CONDITIONS',
    CAMPAIGN_CONTRACT = 'CAMPAIGN_CONTRACT',
    HUB_CAMPAIGN_CONTRACT = 'HUB_CAMPAIGN_CONTRACT',
    AMBASSADOR_CONTRACT = 'AMBASSADOR_CONTRACT',
}

export type AmbassadorContractAcceptance = {
    id: number;
    clientId: number;
    contractVersionId: number;
    userClientId: number;
    acceptedContractDate: Date | null;
    acceptedContractIP: string | null;
    acceptedContractUserAgent: string | null;
    acceptedContractLegalName: string | null;
};

export type ClientContractAcceptance = {
    id: number;
    clientId: number;
    contractVersionId: number;
    acceptedAt: Date;
    acceptedByUserId: number;
};

export type ContractVersion = {
    id: number;
    contractId: number;
    versionNumber: number;
    createdAt: Date;
    updatedAt: Date;
    deletedAt: Date | null;
    description: string | null;
    s3Key: string;
    s3Bucket: string;
    uploadedByUserId: number;
    deletedByUserId?: number | null;
    clientContractAcceptance?: ClientContractAcceptance[];
    uploadedByUser?: Pick<User, 'firstName' | 'lastName'>;
};

export type Contract = {
    id: number;
    clientId: number | null;
    createdAt: Date;
    updatedAt: Date;
    deletedAt: Date | null;
    name: string;
    type: ContractType;
    contractVersion: ContractVersion[];
    deletedByUserId: number | null;
};
